module.exports = __webpack_public_path__ + "img/0-map-c@2x.2de48f57.png";